import * as S from "./styles";

export type NoMatchProps = {
  message?: string;
};

const NoMatch: React.FC<NoMatchProps> = ({ message = "No Match" }) => {
  return (
    <S.NoMatchContainer>
      <h1>{message}</h1>
    </S.NoMatchContainer>
  );
};

export default NoMatch;
